export default __webpack_public_path__ + "static/media/no-img.8e8ad1d9.png";